import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Button} from "@mui/material";
import {constantsErrorMessages} from "../../../../Constants";
import EstimateItem from "../estimate/EstimateItem";
import JobService from "../../../../API/orders/job/JobService";
import OrderService from "../../../../API/orders/orders/organization/OrderService";
import {BreadcrumbsComponent} from "../../../../components/UI/breadcrumb/BreadcrumbComponent";
import {ButtonGroupTabBar} from "../../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import ModalAlert from "../../../../components/UI/table/customer-detales/ModalAlert";
import {EditLocalStoragePagesData} from "../../../../utils/EditLocalStoragePagesData";
import FilesItem from "../../../customer/orders/FilesItem";
import CompositionRequestsCuttingTable
    from "../../../../components/UI/table/orders/organization/order-composition/CompositionRequestsCuttingTable";
import OrganizationOrderCompositionView
    from "../../../../components/composition/OrganizationOrderCompositionView";

const OrderCompositionItem = () => {
        const pathname = useLocation().pathname
        const params = useParams();
        const [tab, setTab] = useState(3);
        const {numberCustomer: numberCustomerParam, orderId} = params;

        const [alertData, setAlertData] = useState({});
        const [technicalMapData, setTechnicalMapData] = useState([]);
        const [orderFulComposition, setOrderFulComposition] = useState(null);
        const [compositionLoading, setCompositionLoading] = useState(true);
        const [tableOptions, setTableOptions] = useState({pageIndex: 0, pageSize: 100, totalElements: 0, searchData: ""})

        const numberCustomer = orderFulComposition?.numberCustomer ?? numberCustomerParam;

        const handleModalAlert = (message, type = "error") => {
            setAlertData({
                type: type,
                open: true,
                message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
            })
        }

        const getStartPageSize = () => {
            const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
            const savedTab = pagesData[pathname]?.tab
            const pageSize = pagesData[pathname]?.pageSize
            pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
            savedTab && setTab(savedTab)
        }

        useEffect(() => {
            JobService.getJobsByOrderId(orderId).then(function (response) {
                setTechnicalMapData(response.data);
            })
                .catch(function (error) {
                    console.log(error);
                });
        }, [orderId]);

        useEffect(() => {
            setCompositionLoading(true);
            OrderService.getByIdForFulComposition(orderId)
                .then((response) => {
                    setOrderFulComposition(response.data);
                })
                .catch((error) => {
                    handleModalAlert(error);
                })
                .finally(() => {
                    setCompositionLoading(false);
                });
        }, [orderId]);

        useEffect(() => {
            getStartPageSize()
        }, []);

        const handleChangeTab = (nextTab) => {
            setTab(nextTab)
            EditLocalStoragePagesData(pathname, "tab", nextTab)
        }
        const generalTabComponents = [
            {
                tabIndex: 3, label: "Композиция",
                component: <OrganizationOrderCompositionView
                    compositionPair={orderFulComposition?.composition}
                    isLoading={compositionLoading}
                />
            },
            {
                tabIndex: 1, label: "Файлы",
                component:
                    <FilesItem
                        nameOrder={numberCustomer}
                        orderId={orderId}
                        handleModalAlert={handleModalAlert}
                        orderCustomerInOrganization={true}
                    />

            },
            {
                tabIndex: 2, label: "Заявки на раскрой",
                component: <CompositionRequestsCuttingTable
                    orderId={orderId}
                    handleModalAlert={handleModalAlert}
                />
            },
            {
                tabIndex: 5, label: "Фурнитура",
                component: <></>
            },
            {
                tabIndex: 6, label: "Общая смета",
                component: <EstimateItem
                    orderId={orderId}
                    isButtonPurchase={true}
                    enableEditing={true}
                    isActual={true}
                    inWork={true}
                    isComposition={true}
                    handleModalAlert={handleModalAlert}
                />
            },]
        return (
            <Box sx={{padding: "0 30px"}}>
                <BreadcrumbsComponent
                    page={`Заказ: ${numberCustomer}`}
                    path={[
                        {name: "Главная", href: "/"},
                        {name: "Композиции", href: "/organization/orders-composition"},
                    ]}/>
                <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Заказ: {numberCustomer}
                    </Typography>
                    <ButtonGroupTabBar activeTab={tab}>
                        {generalTabComponents.map(({tabIndex, label}) => {
                            return <Button key={tabIndex} tabIndex={tabIndex} onClick={() => handleChangeTab(tabIndex)}>
                                <CheckIcon/>
                                {label}
                            </Button>
                        })}
                    </ButtonGroupTabBar>
                    {generalTabComponents.find(component => component.tabIndex === tab)?.component}
                </Box>
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        );
    }
;

export default OrderCompositionItem;
